/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetFaqList200ResponseData } from './GetFaqList200ResponseData'
import {
  GetFaqList200ResponseDataFromJSON,
  GetFaqList200ResponseDataFromJSONTyped,
  GetFaqList200ResponseDataToJSON,
} from './GetFaqList200ResponseData'

/**
 *
 * @export
 * @interface GetFaqList200Response
 */
export interface GetFaqList200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetFaqList200Response
   */
  status: boolean
  /**
   *
   * @type {GetFaqList200ResponseData}
   * @memberof GetFaqList200Response
   */
  data: GetFaqList200ResponseData
}

/**
 * Check if a given object implements the GetFaqList200Response interface.
 */
export function instanceOfGetFaqList200Response(
  value: object
): value is GetFaqList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetFaqList200ResponseFromJSON(
  json: any
): GetFaqList200Response {
  return GetFaqList200ResponseFromJSONTyped(json, false)
}

export function GetFaqList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetFaqList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetFaqList200ResponseDataFromJSON(json['data']),
  }
}

export function GetFaqList200ResponseToJSON(
  value?: GetFaqList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetFaqList200ResponseDataToJSON(value['data']),
  }
}
